<template>
  <transition name="modal">
    <div :id="id" class="modal-mask" @keyup.esc="$emit('close')">
      <div class="modal">
        <div class="modal__header">
          <div class="modal_close">
            <font-awesome-icon icon="times" v-on:click="$emit('close')" />
          </div>
          <slot name="header"></slot>
        </div>
        <div class="modal__content">
          <div class="modal__body">
            <slot name="form"></slot>
          </div>
          <div class="modal__footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style src="./css/modalDialogFrame.css"></style>

<script>
export default {
  props: ["id"],
  name: "ModelDialog"
};
</script>
